import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-provider-requests',
    templateUrl: './provider-requests.component.html',
    styleUrls: ['./provider-requests.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProviderRequestsComponent {

}
